import { Routes } from '@angular/router';
import { LayoutComponent } from './components/shared/layout/layout.component';
import { Error403Component } from './components/shared/error-code/403Component';
import { Error404Component } from './components/shared/error-code/404.component';
import { Error500Component } from './components/shared/error-code/500.component';
import { LoadschedulesComponent } from './components/loadschedules/loadschedules.component';
import { GeneratorsComponent } from './components/feedstock/generators/generators.component';
import { StreamsComponent } from './components/feedstock/streams/streams.component';
import { PricematrixComponent } from './components/feedstock/pricematrix/pricematrix.component';
import { FeedstockComponent } from './components/feedstock/feedstock.component';

import { MarketsComponent } from './components/markets/markets.component';
import { HaulersComponent } from './components/haulers/haulers.component';
import { SitesComponent } from './components/sites/sites.component';
import { DosingratesComponent } from './components/dosingrates/dosingrates.component';

import { DosingbalanceComponent } from './components/dosingbalance/dosingbalance.component';
import { InvoiceprocessComponent } from './components/invoiceprocess/invoiceprocess.component';
import { DataoverrideComponent } from './components/dataoverride/dataoverride.component';
import { VgsgasinputComponent } from './components/vgsgasinput/vgsgasinput.component';
import { SiteLockCodesComponent } from './components/sitelockcodes/sitelockcodes.component';
import { LoadprojectionComponent } from './components/loadprojection/loadprojection.component';
import { LabdatacaptureComponent } from './components/labdatacapture/labdatacapture.component';
import { ToteTransactionComponent } from './components/tote-transaction/tote-transaction.component';
import { SitedatacaptureComponent } from './components/sitedatacapture/sitedatacapture.component';
import { DailyDosingTabsComponent } from './components/dailydosing/daily-dosing-tabs.component';
import { OraoutboundComponent } from './components/oraoutbound/oraoutbound.component';
import { DeepackComponent } from './components/deepack/deepack.component';
import { HomeComponent } from './components/home/home.component';
import { PendingChangesGuard } from './components/loadschedules/pending-changes.guard';
import { LoadModelComponent } from './components/load-model/load-model.component';
import { SitedowntimeComponent } from './components/sitedowntime/sitedowntime.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'loadschedule/:id', component: LoadschedulesComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'generators', component: GeneratorsComponent },
      { path: 'streams', component: StreamsComponent },
      { path: 'pricematrix', component: PricematrixComponent },
      { path: 'hauler', component: HaulersComponent },
      { path: 'deepack', component: DeepackComponent },
      { path: 'feedstock', component: FeedstockComponent },
      { path: 'market', component: MarketsComponent },
      { path: 'site', component: SitesComponent },
      { path: 'dailydosing', component: DailyDosingTabsComponent },
      { path: 'dosingrates', component: DosingratesComponent },
      { path: 'dosingbalance', component: DosingbalanceComponent },
      { path: 'invoiceprocess', component: InvoiceprocessComponent },
      { path: '403', component: Error403Component },
      { path: '404', component: Error404Component },
      { path: '500', component: Error500Component },
      { path: 'loadprojections', component: LoadprojectionComponent},
      { path: 'dataoverride', component: DataoverrideComponent},
      { path: 'vgsgasinput', component: VgsgasinputComponent},
      { path: 'sitelockcodes', component: SiteLockCodesComponent},
      { path: 'labdatacapture', component: LabdatacaptureComponent},
      { path: 'sitedatacapture', component: SitedatacaptureComponent},
      { path: 'tote-transactions', component: ToteTransactionComponent },
      { path: 'oraoutbound', component: OraoutboundComponent},
      { path: 'loadmodel', component: LoadModelComponent},
      { path: 'sitedowntime', component: SitedowntimeComponent}

    ],
  },
];
